/**
 * Feature-local loading key for loading a saved chat session from history.
 *
 * The shared `@labrav/common` `LoadingTypes` enum defines
 * `LABRA_CHAT_FETCH_FUNDING_SUMMARY` (used directly off the enum), but it has no
 * equivalent for the session-load spinner. The loading reducer keys its state by
 * string and `startLoading`/`stopLoading`/`isLoading` all accept a plain string,
 * so we pass this constant directly.
 */
export const LABRA_CHAT_LOAD_SESSION = 'LABRA_CHAT_LOAD_SESSION'
